import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';
import { COLORS } from '../design-system/settings/variables/Colors';
import { useUserActions } from '../auth/hooks/useUserActions';
import {
  GhostPartner,
  getGhostPartner,
  setGhostPartner,
} from '../utils/partnerUser';

const StyledDiv = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  background-color: rgba(255, 0, 0, 0.5);
  color: white;
  z-index: 10001;
  backdrop-filter: blur(4px);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  button {
    font-size: 12px;
    text-decoration: underline;
    cursor: pointer;
    background: transparent;
    color: ${COLORS.whiteBase};
    border: none;
  }
`;

const defaultValue = import.meta.env.VITE_HIDE_STATUS_BANNER !== 'true';

const PARTNER_LABEL: Record<GhostPartner, string> = { cn: 'CN', bb: 'BB' };

const handleExit = () => {
  window.sessionStorage.removeItem('trueimpact.ghostedUsername');
  setGhostPartner(null);
  window.location.href = '/';
};

// Start where a partner user starts: their widget
const ghostAs = (partner: GhostPartner | null) => {
  setGhostPartner(partner);
  window.location.href = partner ? `/${partner}-widget` : '/';
};

export default function GhostingNoticeBar() {
  const { isGhosting, ghostedUsername, isNPO } = useUserActions();
  const ghostPartner = getGhostPartner();
  const [show, setShow] = useState<boolean>(defaultValue);

  useEffect(() => {
    setShow(isGhosting);
  }, [isGhosting]);

  const handleClose = useCallback(() => {
    setShow(false);
  }, [setShow]);

  if (!isGhosting || !show) return null;

  return (
    <StyledDiv>
      <button onClick={handleClose}>Close</button>
      <strong>
        Ghosting: {ghostedUsername}
        {ghostPartner ? ` (as ${PARTNER_LABEL[ghostPartner]} user)` : ''}
      </strong>
      <span>
        {ghostPartner && (
          <button onClick={() => ghostAs(null)}>Ghost as TI user</button>
        )}
        {(isNPO || ghostPartner) &&
          (Object.keys(PARTNER_LABEL) as GhostPartner[])
            .filter(p => p !== ghostPartner)
            .map(p => (
              <button key={p} onClick={() => ghostAs(p)}>
                Ghost as {PARTNER_LABEL[p]} user
              </button>
            ))}
        <button onClick={handleExit}>Back to Super Admin account</button>
      </span>
    </StyledDiv>
  );
}
